import { hasCapability, type User } from "../base";

export const personGroup = {
  create: (user: User) => hasCapability(user, "personGroup.create"),
  delete: (user: User) => hasCapability(user, "personGroup.delete"),
  read: (user: User) => hasCapability(user, "personGroup.read"),
  update: (user: User) => hasCapability(user, "personGroup.update"),
  updateKey: (user: User) => hasCapability(user, "personGroup.updateKey"),
};
